import { defineStore } from 'pinia'
import { notificationsApi, type IActionRequiredCounters } from '../services/notificationsApi'

export const useActionRequiredCountersStore = defineStore('actionRequiredCounters', {
  state: () => ({
    adverse_events: 0,
    tickets: 0,
    improvements: 0,
    audits: 0,
    tasks: 0,
    isLoading: false,
  }),

  getters: {
    total: state => state.adverse_events + state.tickets + state.improvements + state.audits + state.tasks,
    adverse: state => state.adverse_events,
  },

  actions: {
    setCounters(data: Partial<IActionRequiredCounters> | Record<string, any>) {
      if (!data || typeof data !== 'object') return

      const adv = data.adverse_events ?? data.adverse ?? data.modules?.adverse_events
      if (typeof adv === 'number') this.adverse_events = Math.max(0, adv)

      const tick = data.tickets ?? data.modules?.tickets
      if (typeof tick === 'number') this.tickets = Math.max(0, tick)

      const imp = data.improvements ?? data.modules?.improvements
      if (typeof imp === 'number') this.improvements = Math.max(0, imp)

      const aud = data.audits ?? data.modules?.audits
      if (typeof aud === 'number') this.audits = Math.max(0, aud)

      const tsk = data.tasks ?? data.modules?.tasks
      if (typeof tsk === 'number') this.tasks = Math.max(0, tsk)
    },

    async fetchCounters() {
      this.isLoading = true
      try {
        const response = await notificationsApi.getCounters()
        if (response?.data) {
          this.setCounters(response.data)
        }
      } catch (error) {
        console.warn('Не удалось загрузить счётчики «Требует действия»:', error)
      } finally {
        this.isLoading = false
      }
    },
  },
})
